import { render, staticRenderFns } from "./companyList.vue?vue&type=template&id=087fce24&scoped=true"
import script from "./companyList.vue?vue&type=script&lang=js"
export * from "./companyList.vue?vue&type=script&lang=js"
import style0 from "./companyList.vue?vue&type=style&index=0&id=087fce24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087fce24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087fce24')) {
      api.createRecord('087fce24', component.options)
    } else {
      api.reload('087fce24', component.options)
    }
    module.hot.accept("./companyList.vue?vue&type=template&id=087fce24&scoped=true", function () {
      api.rerender('087fce24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/components/companyList.vue"
export default component.exports